import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Checkbox, Col, Row } from 'antd';

import { useTranslation } from 'react-i18next';

import { ReactComponent as Delete } from '../../assets/delete-black-icon.svg';
import { numberWithSpacesInter } from '../../helpers/formatInteger';
import CustomSelect from '../../components/CustomSelect/CustomSelect';
import CustomInputNumber from '../../components/CustomInputNumber/CustomInputNumber';
import { formatter, parser } from '../../helpers/formatterInput';
import { decimalSeparator as decFunc} from '../../helpers/decimalSeparator';

const PortfolioFixationItem = (props) => {
  const {
    i, selectedInstruments, setSelectedInstruments, handleSelect,
    renderSelectOption, handleChangeFix, handleDelete, cashesList
  } = props;
  const { t } = useTranslation('');
  const [cheked, setCheked] = useState(false);
  const [isCashes, setIsCashes] = useState(false);
  const [setsearchFixation, setSetsearchFixation] = useState(null);
  const [filteredFix, setFilteredFix] = useState(renderSelectOption);

  const decimalSeparator = decFunc();

  useEffect(() => {
    const { fixed, units_number, financial_instrument_id } = i;
    if (fixed && fixed === units_number) {
      setCheked(true);
    } else setCheked(false);
    if (financial_instrument_id) {
      setIsCashes(cashesList.some(i => i.ID === financial_instrument_id));
    }
  }, [i, selectedInstruments]);

  useEffect(() => {
    if (setsearchFixation?.length > 2) {
      const render = renderSelectOption.filter(i => i?.label.toLowerCase().includes(setsearchFixation.toLowerCase()));
      setFilteredFix(render);
    } else setFilteredFix(renderSelectOption);
  }, [setsearchFixation]);

  const changeFix = (value, key) => {
    if (i.unitsNumber === value) {
      setCheked(true);
    } else setCheked(false);
    handleChangeFix(value, key);
  };

  const handleChangeCheck = (key, total, name = 'fixed', value) => {
    const setValue = name === 'fixed' ? total : value?.target?.checked;
    if (!cheked && name === 'fixed') {
      const array = selectedInstruments.map(i => i.key === key ? { ...i, [name]: setValue } : i);
      setCheked(true);
      setSelectedInstruments(array);
    } else if (name === 'is_approved_instrumen') {
      const array = selectedInstruments.map(i => i.key === key ? { ...i, [name]: setValue, fixed: 0 } : i);
      setSelectedInstruments(array);
    } else {
      setCheked(false);
    }
  };

  return (
    <div className='bias-row-wrapper' key={i.id}>
      <Row className="bias-form-row" align="middle" >
        <Col style={{ flexBasis: '20%' }} className='fixation-asset-name'>
          {i?.financial_asset_name ?? '- - - - - - - - - - - - - -'}
        </Col>
        <Col style={{ width: '29.16%' }}>
          <CustomSelect
            showSearch
            width='100%'
            className="custom-select"
            labelInValue
            value={{ value: i.id, label: i.instrument_name }}
            onSearch={(value) => setSetsearchFixation(value)}
            onSelect={(value) => handleSelect(value, i?.key)}
            options={filteredFix}
            placeholder={t('PRODUCT_NAME_ISIN')}
            filterOption={false}
          />
        </Col>
        <Col style={{ flexBasis: '12.33%' }} className='fixation-units'>
          {numberWithSpacesInter(i?.units_number, null, 4)}
        </Col>
        <Col style={{ flexBasis: '13.85%' }} >
          <CustomInputNumber
            decimalSeparator={decimalSeparator}
            width='100%'
            disabled={(cheked && !isCashes) || i.is_approved_instrumen}
            value={i?.fixed}
            onChange={(value) => changeFix(value, i?.key)}
            min={0}
            max={isCashes ? false : i?.units_number}
            step={1}
            formatter={formatter}
            parser={parser}
          />
        </Col>
        <Col style={{ textAlign: 'center', flexBasis: '6.33%' }}>
          <Checkbox
            className='fixation-checkbox'
            disabled={i.is_approved_instrumen}
            checked={cheked}
            onChange={() => handleChangeCheck(i?.key, i?.units_number)} />
        </Col>
        <Col style={{ flexBasis: '12%' }} className='fixation-units'>
          {numberWithSpacesInter(i?.latest_value_sek * i?.fixed, 0)} kr
        </Col>
        <Col style={{ flexBasis: '6.33%' }}>
          <div
            style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Button
              type='text'
              style={{ marginTop: '5px', cursor: 'pointer' }}
              icon={<Delete />}
              onClick={() => handleDelete(i?.key)}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default PortfolioFixationItem;

PortfolioFixationItem.propTypes = {
  i: PropTypes.object,
  selectedInstruments: PropTypes.array,
  renderSelectOption: PropTypes.array,
  cashesList: PropTypes.array,
  setSelectedInstruments: PropTypes.func,
  handleSelect: PropTypes.func,
  handleChangeFix: PropTypes.func,
  handleDelete: PropTypes.func,
};
